import React, { Component } from "react";
import Header from "./presenter";

class Container extends Component {
    render() {
        return (
            <Header
                {...this.props}
                handleLogout={this._logout}
            />
        );
    }

    _logout = event => {
        const { logout } = this.props;
        logout();
    }
}

export default Container;
